import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-input',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.css'],
    host: {
        '[class.compact]': 'compact',
    },
})
export class InputComponent implements ControlValueAccessor, OnInit {
    @Input() label = '';
    @Input() inputId = '';
    @Input() type = 'text';
    @Input() placeholder = '';
    @Input() tooltip = '';
    @Input() required = false;
    @Input() disabled = false;
    @Input() submitted = false;
    @Input() requiredError = null;
    @Input() requiredMayusculas = false;
    @Input() compact = false;
    @Input() styleClasses = '';

    value = '';
    private blurred = false;

    constructor(@Optional() @Self() public ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.requiredError = this.requiredError ?? 'Campo '+this.label+' requerido';
        this.value = this.toUpperIfNeeded(this.value);
    }

    get invalid(): boolean {
        return !!this.ngControl?.control?.invalid;
    }

    get touched(): boolean {
        return this.blurred || !!this.ngControl?.touched;
    }

    get showError(): boolean {
        return (this.submitted || this.touched) && this.invalid;
    }

    onChange: (value: string) => void = () => {};
    onTouched: () => void = () => {};

    writeValue(value: string): void {
        this.value = this.toUpperIfNeeded(value ?? '');
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const caret = input.selectionStart;
        const value = this.toUpperIfNeeded(input.value);

        input.value = value;
        this.value = value;
        this.onChange(value);

        if (this.requiredMayusculas && caret !== null) {
            input.setSelectionRange(caret, caret);
        }
    }

    onBlur(): void {
        this.blurred = true;

        if (this.requiredMayusculas) {
            const value = this.toUpperIfNeeded(this.value);
            if (value !== this.value) {
                this.value = value;
                this.onChange(value);
            }
        }

        this.onTouched();
    }

    private toUpperIfNeeded(value: string): string {
        return this.requiredMayusculas ? (value ?? '').toUpperCase() : value;
    }

    mostrarTooltip(): void {
        if (!this.tooltip) {
            return;
        }

        Swal.fire('', this.tooltip, 'info');
    }
}
